var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page"},[_c(_setup.SunsetNoteStatsQueryBar,{attrs:{"hard-reload-on-change":true,"path-base":"/sunset/reports/note-stats/global"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }